<template>
    <div class="gst-table-no-data text-center">
        <IconTableChart class="icon--no-data" />
        <p v-if="isFirstLoad">
            {{ $t('default') }}
        </p>
        <p v-else>
            {{ $t('noData') }}
        </p>
    </div>
</template>

<script>
import { IconTableChart } from '@assets';

export default {
    name: 'NoDataTable',
    i18nOptions: {
        namespaces: '_common',
        keyPrefix: 'messages.tables',
    },
    components: {
        IconTableChart,
    },
    props: {
        isFirstLoad: {
            type: Boolean,
            default: true,
            required: true,
        },
    },
};
</script>
<style lang="scss">
@import '@scssVariables';

.gst-table-no-data {
    .icon--no-data {
        fill: theme-color('quaternary');
    }
}
</style>
